import React, { useEffect } from 'react';
import pluginConfig from './CookieConsentConfig';
import 'vanilla-cookieconsent/dist/cookieconsent.css';
import 'vanilla-cookieconsent';

const CookieConsentComponent: React.FC = () => {
    useEffect(() => {
        /**
         * useEffect is executed twice (React 18+),
         * make sure the plugin is initialized and executed once
         */
        if (!document.getElementById('cc--main')) {
            window.CookieConsentApi = window.initCookieConsent();
            window.CookieConsentApi.run(pluginConfig);
        }
    }, []);

    return null;
};

export default CookieConsentComponent;
